import React, { useState } from "react";

// Cancelling zeroes an On Demand invoice for a service that was attempted
// but not charged, while keeping its line items as the service record - so
// a reason is required for later reference.
const CancelInvoiceModal = ({ isOpen, onClose, onSubmit, isLoading = false }) => {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(reason.trim(), () => setReason(""));
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: isOpen ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content shadow-lg border-0">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title fw-bold fs-4">Cancel Invoice</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body py-4">
            <p className="fs-6 text-gray-700">
              The invoice total will be set to $0.00 and it will be marked
              Cancelled. The services on it stay on record, and it can be
              reinstated later.
            </p>
            <div className="mb-3">
              <label className="form-label fw-bold required">Reason</label>
              <textarea
                rows="3"
                className="form-control"
                placeholder="e.g. Jump start did not start the vehicle; customer declined a tow."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
          </div>
          <div className="modal-footer border-0 pt-0">
            <button
              type="button"
              className="btn btn-light-secondary fw-bold"
              onClick={handleClose}
              disabled={isLoading}
            >
              Back
            </button>
            <button
              type="button"
              className="btn btn-danger fw-bold"
              onClick={handleSubmit}
              disabled={isLoading || !reason.trim()}
            >
              {isLoading ? "Cancelling..." : "Cancel Invoice"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelInvoiceModal;
